export function setLoadingUploadProductsExcel (state, bool) {
    state.loading.upload_products_excel = bool;
}

export function setModalsUploadProductsExcelShow (state, bool) {
    state.modals_upload_products_excel.show = bool;
}

export function setModalsUploadProductsExcelPreloader (state, bool) {
    state.modals_upload_products_excel.preloader = bool;
}


// WEBPACK FOOTER //
// ./src/modules/modal-upload-products-excel/mutations.js